import Service from '../Service'
import {http} from '../config'

export default class DoadorService extends Service{

    constructor(){
        super('doador');
    }

    GetFiltro(parametros, filter){
        if (filter) {
            let paramTemp = '';

            if(filter.contribuicaoId && filter.contribuicaoId != -1){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `tipoContribuicao eq ${filter.contribuicaoId}`;
            }

            if(filter.formaDeDoacaoId && filter.formaDeDoacaoId != -1){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `formaDoacao eq ${filter.formaDeDoacaoId}`;
            }

            if(filter.doadorId && filter.doadorId != 0){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `indicadorId eq ${filter.doadorId}`;
            }
            
            if(filter.regiaoId && filter.regiaoId != 0){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `regiaoId eq ${filter.regiaoId}`;
            }

            if(filter.mesInicial != 0){
                parametros += `&mesInicial=${filter.mesInicial}`;
            }

            if(filter.mesFinal != 0){
                parametros += `&mesFinal=${filter.mesFinal}`;
            }

            parametros = this.AppendFiltro(parametros, paramTemp);
        }

        return parametros;
    }

    GetFiltroListagem(parametros, filter){
        if (filter) {
            let paramTemp = '';

            if (filter.nome){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `Contains(nome, '${filter.nome}')`;
            }

            if (filter.cpfCnpj){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `Contains(cpfCnpj, '${filter.cpfCnpj}')`;
            }

            if (filter.situacao){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `situacao eq '${filter.situacao}'`;
            }

            if (filter.codigo){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `id eq ${filter.codigo}`;
            }

            parametros = this.AppendFiltro(parametros, paramTemp);
        }

        return parametros;
    }

    AppendFiltro(parametros, filtro){
        if(!filtro){
            return parametros;
        }

        if(parametros.indexOf('$filter=') > -1){
            parametros += ` and ${filtro}`;
            return parametros;
        }

        if(parametros && parametros !== '?'){
            parametros += '&';
        }
        else{
            parametros = '?';
        }

        parametros += `$filter=${filtro}`;

        return parametros;
    }

    ListarComFiltro(page, pageSize, sortby, desc, search, columns, filter, include){
        let parametros = this.GetParamentroPaginacaoOrdenacao(page, pageSize, sortby, desc, search, columns);

        parametros = this.GetFiltro(parametros, filter);
        parametros = this.GetFiltroListagem(parametros, filter);

        return http.get(`${this._nomeControle}${parametros}`, this.GetHeader(include));
    }

    TotalizadoresComFiltro(search, columns, filter, include){
        let parametros = this.GetParamentroPaginacaoOrdenacao(null, null, null, [], search, columns);

        parametros = this.GetFiltro(parametros, filter);
        parametros = this.GetFiltroListagem(parametros, filter);

        if(parametros === '?'){
            parametros = '';
        }

        return http.get(`${this._nomeControle}/Totalizadores${parametros}`, this.GetHeader(include));
    }

    FiltroComplementar(page, pageSize, sortby, desc, search, columns, filter, include){
        let parametros = this.GetParamentroPaginacaoOrdenacao(page, pageSize, sortby, desc, search, columns);

        parametros = this.GetFiltro(parametros, filter);

        return http.get(`${this._nomeControle}/FiltroComplementar/${parametros}`, this.GetHeader(include));
    }

    AutoComplete(q) {
        return http.get(this._nomeControle + "/AutoComplete?q=" + q);
    }

    VerificarExistente(cpfCnpj) {
        return http.get(this._nomeControle + "/VerificarExistente", {
            params: {
                cpfCnpj
            }
        });
    }

    AlterarContato(doadorId, contatoId, modelo){
        return http.put(`${this._nomeControle}/${doadorId}/contato/${contatoId}`, modelo);
    }

    IncluirContato(doadorId, modelo){
        return http.post(`${this._nomeControle}/${doadorId}/contato`, modelo);
    }

    ExcluirContato(doadorId, contatoId){
        return http.delete(`${this._nomeControle}/${doadorId}/contato/${contatoId}`);
    }

    Aniversariantes(){
        return http.get(`${this._nomeControle}/Aniversariantes`);
    }
}
